var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.008 7.28v3.221h0a2.689 2.689 0 00-1.4.091 2.61 2.61 0 00-1.688 1.836 2.645 2.645 0 003.089 3.248v3.221a2.112 2.112 0 01-2.112 2.112h-3.221v0c.094-.466.062-.95-.091-1.4a2.61 2.61 0 00-1.836-1.687A2.645 2.645 0 0010.5 21.01l-3.22-.001a2.111 2.111 0 01-2.112-2.111v-3.221a2.645 2.645 0 01-3.088-3.247 2.61 2.61 0 011.688-1.836c.45-.154.933-.186 1.4-.091h0V7.28A2.112 2.112 0 017.28 5.17h3.221a2.645 2.645 0 013.247-3.088c.859.216 1.55.85 1.836 1.688.154.45.186.934.091 1.4h3.222a2.111 2.111 0 012.112 2.112",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgComponents;